import React from 'react';

export const ErrorMessage = (props) => (
    <div className="error-message-container">
        <h1>{props.message}</h1>
    </div>
);


// WEBPACK FOOTER //
// ./src/Components/ErrorMessage.js